import { render, staticRenderFns } from "./pageForm.vue?vue&type=template&id=f98f8a22&scoped=true&"
import script from "./pageForm.vue?vue&type=script&lang=js&"
export * from "./pageForm.vue?vue&type=script&lang=js&"
import style0 from "./pageForm.vue?vue&type=style&index=0&id=f98f8a22&scoped=true&lang=scss&"
import style1 from "./pageForm.vue?vue&type=style&index=1&id=f98f8a22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f8a22",
  null
  
)

export default component.exports